import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth/auth';

type VerifyState = 'loading' | 'success' | 'error' | 'missing-token';

@Component({
  selector: 'app-verify-email',
  imports: [RouterLink],
  templateUrl: './verify-email.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './verify-email.css',
})
export class VerifyEmail implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  readonly state = signal<VerifyState>('loading');

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.state.set('missing-token');
      return;
    }

    try {
      await this.auth.verifyEmail(token);
      this.state.set('success');
    } catch {
      this.state.set('error');
    }
  }
}
